import "./footer.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import flagBrazil from "../../imagens/flags/bandeiraBrasil.png"
import flagEUA from "../../imagens/flags/bandeiraEUA.png"
import flagEU from "../../imagens/flags/EU.png"


function Footer() {

    return (
        <div className="container-fluid p-0">
            <footer className="footer" id="footer">
                <div className="row align-items-center m-0 justify-content-around pt-1">
                    <div className="p-0 col-md-6 text-custom col-sm-6 custom-color text-center  mb-md-0">
                        <p className="m-0">© {new Date().getFullYear()} spiauto.com. All rights reserved.</p>
                    </div>
                    <div className="col-lg-6 d-flex justify-content-around align-items-center text-center p-0">
                        <div className="d-flex flex-column align-items-center">
                            <div className="icon-and-flag">
                                <FontAwesomeIcon icon={faLocationDot} className="custom-icon"></FontAwesomeIcon>
                                <span><img src={flagBrazil} alt="Brazil Flag" className="flag-footer ms-2" /></span>
                            </div>
                            <p className="size-test bgColorCustom text-center m-0 mt-2">SSA Automotive Systems</p>

                            <p className="footerAddress m-0 custom-size brazil-bottom">
                                Av. Das Indústrias, 1001 <br />
                                Ouro Fino, Brazil<br />
                            </p>
                        </div>
                        <div className="d-flex flex-column align-items-center">
                            <div className="icon-and-flag">
                                <FontAwesomeIcon icon={faLocationDot} className="custom-icon"></FontAwesomeIcon>
                                <span><img src={flagEUA} alt="Brazil Flag" className="flag-footer ms-2" /></span>
                            </div>
                            <p className="size-test bgColorCustom text-center m-0 mt-2">SPI Automotive NA Inc</p>
                            <p className="footerAddress  m-0 custom-size unitedstates-bottom">  
                                1862, Start-Batt drive, 48309<br />
                                Rochester Hills, Michigan - USA<br />
                            </p>
                        </div>
                        <div className="d-flex flex-column align-items-center">
                            <div className="icon-and-flag">
                                <FontAwesomeIcon icon={faLocationDot} className="custom-icon"></FontAwesomeIcon>
                                <span><img src={flagEU} alt="Brazil Flag" className="flag-footer ms-2" /></span>
                            </div>
                            <p className="size-test bgColorCustom text-center m-0 ">SPI Automotive Europe</p>
                            <p className="footerAddress m-0 custom-size EU-bottom">
                                Calle Gabiria 110-148<br />
                                Polígono Industrial Gabiria<br />
                                20305 Irun (Gipuzkoa)
                                - Spain<br />
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}
export default Footer